
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as indexBBDy8dWL6V1bXlsA45TVU5_45WIGiCBbqAHQWYoUJHxCYMeta } from "/home/vsts/work/1/s/pages/marketplace/index.vue?macro=true";
import { default as indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta } from "/home/vsts/work/1/s/pages/marketplace/news/index.vue?macro=true";
import { default as index6Y8L9Tl7Xyxo2HI5a4fqfzLYftwcwotT6e_45hskPTb9EMeta } from "/home/vsts/work/1/s/pages/marketplace/search/index.vue?macro=true";
import { default as indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta } from "/home/vsts/work/1/s/pages/marketplace/support/index.vue?macro=true";
import { default as indexixK16Q7Sozmwm9lyUx4aOCuzbnEQrCdgu0s252WNrMcMeta } from "/home/vsts/work/1/s/pages/marketplace/about-us/index.vue?macro=true";
import { default as index3_45QhH57ECAGn5p_45DcfhT2jWOiPKuwhXdE8Fvmx0WtEoMeta } from "/home/vsts/work/1/s/pages/marketplace/partners/index.vue?macro=true";
import { default as indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta } from "/home/vsts/work/1/s/pages/marketplace/webinars/index.vue?macro=true";
import { default as indexaBTxbuDBngsaJVdR2nIqB1wWcmh7u3O_45v2_45TeOzCGTwMeta } from "/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue?macro=true";
import { default as indexH7UpUapKISHt1q2XQZNahPbyEAACcqQKRG6_45a_FFvWAMeta } from "/home/vsts/work/1/s/pages/marketplace/Membership/index.vue?macro=true";
import { default as indexV3V9fl09U7X51Cgi_45VwN7Ev4SBCBZ8xmWvsj_moD_ykMeta } from "/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue?macro=true";
import { default as _91details_93P1EGe__Vtm57UOLaecBAM2ms7nEmyT6frWSvajEKTxUMeta } from "/home/vsts/work/1/s/pages/marketplace/materials/[details].vue?macro=true";
import { default as indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta } from "/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue?macro=true";
import { default as indexYxQXZ2STgU_fCdM1ogOypAhk9yYzbtWkw84rh8Snl9cMeta } from "/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue?macro=true";
import { default as _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta } from "/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue?macro=true";
import { default as index8h0WUiwACDzSyaVRPxDBKdDfc0UzycO_45lr6JNs9wpeQMeta } from "/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue?macro=true";
import { default as indexRzqRL0nd6Vm_45nPkUxcRdRoxEvl7LjHRnYjN9haELnfcMeta } from "/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue?macro=true";
import { default as indexd35vDnHNBEnsP_456rILwVpDHzU77BNL6M_okxuDYKa60Meta } from "/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue?macro=true";
import { default as index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta } from "/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue?macro=true";
import { default as index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta } from "/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue?macro=true";
import { default as indexDNeI_457GE0_bmM0_D9FpfbZlJshHeQ_45eFdl4INf_4564LgMeta } from "/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue?macro=true";
import { default as indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta } from "/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue?macro=true";
import { default as indexHC4CogMG_DZSE2jVH9w6jrUSUP74TRPdNpAoCYNVt_IMeta } from "/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue?macro=true";
import { default as indextGB2md8Ogi6GWRlDzY93fnNwGze5TaELiXjfctPuORMMeta } from "/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue?macro=true";
import { default as _91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta } from "/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue?macro=true";
import { default as index8BX8o2uA_YjqjMpk2IydZon_45xAym_YWwIA72kn8c77AMeta } from "/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue?macro=true";
import { default as indexN1XhAJz17kzOdw_SeyZlfxmsoy1KSga1QrDm_Bh1twQMeta } from "/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue?macro=true";
import { default as indexC5wtju7Cvu5dLACIybW7yOUpgKOxOKmUeYpEyBu0_ZEMeta } from "/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue?macro=true";
import { default as indexTOscHOWBCa9KgFnhEbJ5LvYZqjF9qHhviM9J5KqKwtAMeta } from "/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue?macro=true";
import { default as indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta } from "/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue?macro=true";
import { default as indexsb7YGstJv0jAXne7HR7x5RR_450rsMMn1bqhZ6qu5VINsMeta } from "/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue?macro=true";
import { default as indexBXLUdwqngtruG8eohOTs_yhxpAx_ZMglCERNHYSEw0cMeta } from "/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue?macro=true";
import { default as indexwJ93TgE6483Kzk_45vU_45DQHSOOSVljMtYrtMPbsCSiI7EMeta } from "/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue?macro=true";
import { default as indexA1nKFHj1x0oSxlKXQTCv2xzq30hyKFjafg0X2Py7jiIMeta } from "/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue?macro=true";
import { default as indexqxmgDrtNlYQxwcpYcDRE8SmL4p2EtbpJlt0g_45UBi2k0Meta } from "/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue?macro=true";
import { default as component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta } from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw } from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-int",
    path: "/en-int",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-emea",
    path: "/en-emea",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-jp",
    path: "/en-jp",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-tw",
    path: "/en-tw",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-kr",
    path: "/en-kr",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-americas",
    path: "/en-americas",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-asia-pacific",
    path: "/en-asia-pacific",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___ja-jp",
    path: "/ja-jp",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___zh-cn",
    path: "/zh-cn",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "index___zh-tw",
    path: "/zh-tw",
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "marketplace___en-int",
    path: "/en-int/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-emea",
    path: "/en-emea/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-jp",
    path: "/en-jp/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-tw",
    path: "/en-tw/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-kr",
    path: "/en-kr/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-americas",
    path: "/en-americas/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-asia-pacific",
    path: "/en-asia-pacific/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___ja-jp",
    path: "/ja-jp/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___zh-cn",
    path: "/zh-cn/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___zh-tw",
    path: "/zh-tw/marketplace",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-news___en-int",
    path: "/en-int/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-emea",
    path: "/en-emea/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-jp",
    path: "/en-jp/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-tw",
    path: "/en-tw/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-kr",
    path: "/en-kr/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-americas",
    path: "/en-americas/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___ja-jp",
    path: "/ja-jp/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___zh-cn",
    path: "/zh-cn/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___zh-tw",
    path: "/zh-tw/marketplace/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-search___en-int",
    path: "/en-int/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-emea",
    path: "/en-emea/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-jp",
    path: "/en-jp/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-tw",
    path: "/en-tw/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-kr",
    path: "/en-kr/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-americas",
    path: "/en-americas/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___ja-jp",
    path: "/ja-jp/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___zh-cn",
    path: "/zh-cn/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___zh-tw",
    path: "/zh-tw/marketplace/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-support___en-int",
    path: "/en-int/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-emea",
    path: "/en-emea/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-jp",
    path: "/en-jp/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-tw",
    path: "/en-tw/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-kr",
    path: "/en-kr/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-americas",
    path: "/en-americas/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___ja-jp",
    path: "/ja-jp/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___zh-cn",
    path: "/zh-cn/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___zh-tw",
    path: "/zh-tw/marketplace/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-about-us___en-int",
    path: "/en-int/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-emea",
    path: "/en-emea/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-jp",
    path: "/en-jp/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-tw",
    path: "/en-tw/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-kr",
    path: "/en-kr/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-americas",
    path: "/en-americas/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___ja-jp",
    path: "/ja-jp/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___zh-cn",
    path: "/zh-cn/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___zh-tw",
    path: "/zh-tw/marketplace/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-partners___en-int",
    path: "/en-int/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-emea",
    path: "/en-emea/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-jp",
    path: "/en-jp/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-tw",
    path: "/en-tw/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-kr",
    path: "/en-kr/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-americas",
    path: "/en-americas/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___ja-jp",
    path: "/ja-jp/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___zh-cn",
    path: "/zh-cn/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___zh-tw",
    path: "/zh-tw/marketplace/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-webinars___en-int",
    path: "/en-int/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-emea",
    path: "/en-emea/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-jp",
    path: "/en-jp/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-tw",
    path: "/en-tw/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-kr",
    path: "/en-kr/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-americas",
    path: "/en-americas/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___ja-jp",
    path: "/ja-jp/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___zh-cn",
    path: "/zh-cn/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___zh-tw",
    path: "/zh-tw/marketplace/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-free-trial___en-int",
    path: "/en-int/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-emea",
    path: "/en-emea/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-jp",
    path: "/en-jp/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-tw",
    path: "/en-tw/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-kr",
    path: "/en-kr/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-americas",
    path: "/en-americas/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___ja-jp",
    path: "/ja-jp/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___zh-cn",
    path: "/zh-cn/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___zh-tw",
    path: "/zh-tw/marketplace/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-Membership___en-int",
    path: "/en-int/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-emea",
    path: "/en-emea/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-jp",
    path: "/en-jp/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-tw",
    path: "/en-tw/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-kr",
    path: "/en-kr/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-americas",
    path: "/en-americas/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___ja-jp",
    path: "/ja-jp/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___zh-cn",
    path: "/zh-cn/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___zh-tw",
    path: "/zh-tw/marketplace/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-int",
    path: "/en-int/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-emea",
    path: "/en-emea/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-jp",
    path: "/en-jp/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-tw",
    path: "/en-tw/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-kr",
    path: "/en-kr/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-americas",
    path: "/en-americas/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-materials-details___en-int",
    path: "/en-int/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-emea",
    path: "/en-emea/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-jp",
    path: "/en-jp/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-tw",
    path: "/en-tw/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-kr",
    path: "/en-kr/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-americas",
    path: "/en-americas/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___ja-jp",
    path: "/ja-jp/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___zh-cn",
    path: "/zh-cn/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___zh-tw",
    path: "/zh-tw/marketplace/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-products-id___en-int",
    path: "/en-int/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-emea",
    path: "/en-emea/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-jp",
    path: "/en-jp/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-tw",
    path: "/en-tw/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-kr",
    path: "/en-kr/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-americas",
    path: "/en-americas/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___ja-jp",
    path: "/ja-jp/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___zh-cn",
    path: "/zh-cn/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___zh-tw",
    path: "/zh-tw/marketplace/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-int",
    path: "/en-int/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-emea",
    path: "/en-emea/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-jp",
    path: "/en-jp/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-tw",
    path: "/en-tw/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-kr",
    path: "/en-kr/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-americas",
    path: "/en-americas/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___ja-jp",
    path: "/ja-jp/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___zh-cn",
    path: "/zh-cn/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___zh-tw",
    path: "/zh-tw/marketplace/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-products-id-slug___en-int",
    path: "/en-int/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-emea",
    path: "/en-emea/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-jp",
    path: "/en-jp/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-tw",
    path: "/en-tw/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-kr",
    path: "/en-kr/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-americas",
    path: "/en-americas/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___ja-jp",
    path: "/ja-jp/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___zh-cn",
    path: "/zh-cn/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___zh-tw",
    path: "/zh-tw/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-help-sales-support___en-int",
    path: "/en-int/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-emea",
    path: "/en-emea/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-jp",
    path: "/en-jp/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-tw",
    path: "/en-tw/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-kr",
    path: "/en-kr/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-americas",
    path: "/en-americas/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___ja-jp",
    path: "/ja-jp/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___zh-cn",
    path: "/zh-cn/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___zh-tw",
    path: "/zh-tw/marketplace/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-int",
    path: "/en-int/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-emea",
    path: "/en-emea/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-jp",
    path: "/en-jp/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-tw",
    path: "/en-tw/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-kr",
    path: "/en-kr/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-americas",
    path: "/en-americas/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___ja-jp",
    path: "/ja-jp/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___zh-cn",
    path: "/zh-cn/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-partners-Ecosystem___zh-tw",
    path: "/zh-tw/marketplace/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-int",
    path: "/en-int/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-emea",
    path: "/en-emea/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-jp",
    path: "/en-jp/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-tw",
    path: "/en-tw/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-kr",
    path: "/en-kr/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-americas",
    path: "/en-americas/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___ja-jp",
    path: "/ja-jp/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___zh-cn",
    path: "/zh-cn/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___zh-tw",
    path: "/zh-tw/marketplace/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-int",
    path: "/en-int/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-int",
    path: "/en-int/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-emea",
    path: "/en-emea/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-jp",
    path: "/en-jp/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-tw",
    path: "/en-tw/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-kr",
    path: "/en-kr/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-americas",
    path: "/en-americas/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___ja-jp",
    path: "/ja-jp/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___zh-cn",
    path: "/zh-cn/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___zh-tw",
    path: "/zh-tw/marketplace/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-int",
    path: "/en-int/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-emea",
    path: "/en-emea/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-jp",
    path: "/en-jp/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-tw",
    path: "/en-tw/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-kr",
    path: "/en-kr/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-americas",
    path: "/en-americas/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___ja-jp",
    path: "/ja-jp/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___zh-cn",
    path: "/zh-cn/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___zh-tw",
    path: "/zh-tw/marketplace/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-int",
    path: "/en-int/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-emea",
    path: "/en-emea/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-jp",
    path: "/en-jp/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-tw",
    path: "/en-tw/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-kr",
    path: "/en-kr/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-americas",
    path: "/en-americas/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___ja-jp",
    path: "/ja-jp/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___zh-cn",
    path: "/zh-cn/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___zh-tw",
    path: "/zh-tw/marketplace/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-int",
    path: "/en-int/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-emea",
    path: "/en-emea/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-jp",
    path: "/en-jp/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-tw",
    path: "/en-tw/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-kr",
    path: "/en-kr/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-americas",
    path: "/en-americas/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___ja-jp",
    path: "/ja-jp/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___zh-cn",
    path: "/zh-cn/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___zh-tw",
    path: "/zh-tw/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-int",
    path: "/en-int/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-emea",
    path: "/en-emea/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-jp",
    path: "/en-jp/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-tw",
    path: "/en-tw/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-kr",
    path: "/en-kr/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-americas",
    path: "/en-americas/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___ja-jp",
    path: "/ja-jp/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___zh-cn",
    path: "/zh-cn/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___zh-tw",
    path: "/zh-tw/marketplace/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-int",
    path: "/en-int/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-emea",
    path: "/en-emea/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-jp",
    path: "/en-jp/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-tw",
    path: "/en-tw/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-kr",
    path: "/en-kr/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-americas",
    path: "/en-americas/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___ja-jp",
    path: "/ja-jp/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___zh-cn",
    path: "/zh-cn/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___zh-tw",
    path: "/zh-tw/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-int",
    path: "/en-int/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-emea",
    path: "/en-emea/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-jp",
    path: "/en-jp/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-tw",
    path: "/en-tw/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-kr",
    path: "/en-kr/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-americas",
    path: "/en-americas/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-int",
    path: "/en-int/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-emea",
    path: "/en-emea/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-jp",
    path: "/en-jp/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-tw",
    path: "/en-tw/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-kr",
    path: "/en-kr/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-americas",
    path: "/en-americas/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___ja-jp",
    path: "/ja-jp/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___zh-cn",
    path: "/zh-cn/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___zh-tw",
    path: "/zh-tw/marketplace/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-int",
    path: "/en-int/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-emea",
    path: "/en-emea/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-jp",
    path: "/en-jp/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-tw",
    path: "/en-tw/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-kr",
    path: "/en-kr/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-americas",
    path: "/en-americas/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___ja-jp",
    path: "/ja-jp/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___zh-cn",
    path: "/zh-cn/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___zh-tw",
    path: "/zh-tw/marketplace/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-int",
    path: "/en-int/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-emea",
    path: "/en-emea/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-jp",
    path: "/en-jp/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-tw",
    path: "/en-tw/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-kr",
    path: "/en-kr/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-americas",
    path: "/en-americas/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___ja-jp",
    path: "/ja-jp/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___zh-cn",
    path: "/zh-cn/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___zh-tw",
    path: "/zh-tw/marketplace/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-int",
    path: "/en-int/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-int",
    path: "/en-int/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-int",
    path: "/en-int/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-emea",
    path: "/en-emea/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-jp",
    path: "/en-jp/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-tw",
    path: "/en-tw/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-kr",
    path: "/en-kr/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-americas",
    path: "/en-americas/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-int",
    path: "/en-int/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-emea",
    path: "/en-emea/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-jp",
    path: "/en-jp/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-tw",
    path: "/en-tw/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-kr",
    path: "/en-kr/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-americas",
    path: "/en-americas/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-int",
    path: "/en-int/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-emea",
    path: "/en-emea/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-jp",
    path: "/en-jp/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-tw",
    path: "/en-tw/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-kr",
    path: "/en-kr/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-americas",
    path: "/en-americas/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___ja-jp",
    path: "/ja-jp/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___zh-cn",
    path: "/zh-cn/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___zh-tw",
    path: "/zh-tw/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-int",
    path: "/en-int/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "index___en-int",
    path: "/en-int",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___en-emea",
    path: "/en-emea",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___en-jp",
    path: "/en-jp",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___en-tw",
    path: "/en-tw",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___en-kr",
    path: "/en-kr",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___en-americas",
    path: "/en-americas",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___en-asia-pacific",
    path: "/en-asia-pacific",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___ja-jp",
    path: "/ja-jp",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___zh-cn",
    path: "/zh-cn",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "index___zh-tw",
    path: "/zh-tw",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "news___en-int",
    path: "/en-int/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___en-emea",
    path: "/en-emea/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___en-jp",
    path: "/en-jp/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___en-tw",
    path: "/en-tw/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___en-kr",
    path: "/en-kr/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___en-americas",
    path: "/en-americas/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___en-asia-pacific",
    path: "/en-asia-pacific/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___ja-jp",
    path: "/ja-jp/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___zh-cn",
    path: "/zh-cn/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "news___zh-tw",
    path: "/zh-tw/news",
    meta: indexC6MdMxEFoMpGFxYvAljGyNGLPDdmVZYuMb_bE0WOw_kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "search___en-int",
    path: "/en-int/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___en-emea",
    path: "/en-emea/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___en-jp",
    path: "/en-jp/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___en-tw",
    path: "/en-tw/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___en-kr",
    path: "/en-kr/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___en-americas",
    path: "/en-americas/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___en-asia-pacific",
    path: "/en-asia-pacific/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___ja-jp",
    path: "/ja-jp/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___zh-cn",
    path: "/zh-cn/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "search___zh-tw",
    path: "/zh-tw/search",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "support___en-int",
    path: "/en-int/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___en-emea",
    path: "/en-emea/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___en-jp",
    path: "/en-jp/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___en-tw",
    path: "/en-tw/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___en-kr",
    path: "/en-kr/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___en-americas",
    path: "/en-americas/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___en-asia-pacific",
    path: "/en-asia-pacific/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___ja-jp",
    path: "/ja-jp/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___zh-cn",
    path: "/zh-cn/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "support___zh-tw",
    path: "/zh-tw/support",
    meta: indexbFsstxy2fmnGZPMHuXPAJObLcprg_DBdwqkJawneGMwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "about-us___en-int",
    path: "/en-int/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___en-emea",
    path: "/en-emea/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___en-jp",
    path: "/en-jp/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___en-tw",
    path: "/en-tw/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___en-kr",
    path: "/en-kr/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___en-americas",
    path: "/en-americas/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___en-asia-pacific",
    path: "/en-asia-pacific/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___ja-jp",
    path: "/ja-jp/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___zh-cn",
    path: "/zh-cn/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "about-us___zh-tw",
    path: "/zh-tw/about-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "partners___en-int",
    path: "/en-int/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___en-emea",
    path: "/en-emea/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___en-jp",
    path: "/en-jp/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___en-tw",
    path: "/en-tw/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___en-kr",
    path: "/en-kr/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___en-americas",
    path: "/en-americas/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___en-asia-pacific",
    path: "/en-asia-pacific/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___ja-jp",
    path: "/ja-jp/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___zh-cn",
    path: "/zh-cn/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "partners___zh-tw",
    path: "/zh-tw/partners",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "webinars___en-int",
    path: "/en-int/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___en-emea",
    path: "/en-emea/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___en-jp",
    path: "/en-jp/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___en-tw",
    path: "/en-tw/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___en-kr",
    path: "/en-kr/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___en-americas",
    path: "/en-americas/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___en-asia-pacific",
    path: "/en-asia-pacific/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___ja-jp",
    path: "/ja-jp/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___zh-cn",
    path: "/zh-cn/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "webinars___zh-tw",
    path: "/zh-tw/webinars",
    meta: indexinBZIasN1UkqPjE7fKX31_QMJ1madGiWmU1MVQgC7HcMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "free-trial___en-int",
    path: "/en-int/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___en-emea",
    path: "/en-emea/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___en-jp",
    path: "/en-jp/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___en-tw",
    path: "/en-tw/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___en-kr",
    path: "/en-kr/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___en-americas",
    path: "/en-americas/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___en-asia-pacific",
    path: "/en-asia-pacific/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___ja-jp",
    path: "/ja-jp/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___zh-cn",
    path: "/zh-cn/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "free-trial___zh-tw",
    path: "/zh-tw/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "Membership___en-int",
    path: "/en-int/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___en-emea",
    path: "/en-emea/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___en-jp",
    path: "/en-jp/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___en-tw",
    path: "/en-tw/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___en-kr",
    path: "/en-kr/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___en-americas",
    path: "/en-americas/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___en-asia-pacific",
    path: "/en-asia-pacific/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___ja-jp",
    path: "/ja-jp/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___zh-cn",
    path: "/zh-cn/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "Membership___zh-tw",
    path: "/zh-tw/Membership",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "pricing-id___en-int",
    path: "/en-int/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___en-emea",
    path: "/en-emea/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___en-jp",
    path: "/en-jp/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___en-tw",
    path: "/en-tw/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___en-kr",
    path: "/en-kr/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___en-americas",
    path: "/en-americas/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___en-asia-pacific",
    path: "/en-asia-pacific/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___ja-jp",
    path: "/ja-jp/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___zh-cn",
    path: "/zh-cn/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "pricing-id___zh-tw",
    path: "/zh-tw/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "materials-details___en-int",
    path: "/en-int/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___en-emea",
    path: "/en-emea/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___en-jp",
    path: "/en-jp/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___en-tw",
    path: "/en-tw/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___en-kr",
    path: "/en-kr/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___en-americas",
    path: "/en-americas/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___en-asia-pacific",
    path: "/en-asia-pacific/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___ja-jp",
    path: "/ja-jp/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___zh-cn",
    path: "/zh-cn/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "materials-details___zh-tw",
    path: "/zh-tw/materials/:details()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "products-id___en-int",
    path: "/en-int/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___en-emea",
    path: "/en-emea/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___en-jp",
    path: "/en-jp/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___en-tw",
    path: "/en-tw/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___en-kr",
    path: "/en-kr/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___en-americas",
    path: "/en-americas/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___en-asia-pacific",
    path: "/en-asia-pacific/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___ja-jp",
    path: "/ja-jp/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___zh-cn",
    path: "/zh-cn/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "products-id___zh-tw",
    path: "/zh-tw/products/:id()",
    meta: { ...(indexSSS2F4IXDe9_H_45WOdNzcgqOFHDYWv9pOLrjyz8RCJ2EMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "help-contact-us___en-int",
    path: "/en-int/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___en-emea",
    path: "/en-emea/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___en-jp",
    path: "/en-jp/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___en-tw",
    path: "/en-tw/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___en-kr",
    path: "/en-kr/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___en-americas",
    path: "/en-americas/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___en-asia-pacific",
    path: "/en-asia-pacific/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___ja-jp",
    path: "/ja-jp/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___zh-cn",
    path: "/zh-cn/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "help-contact-us___zh-tw",
    path: "/zh-tw/help/contact-us",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "products-id-slug___en-int",
    path: "/en-int/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___en-emea",
    path: "/en-emea/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___en-jp",
    path: "/en-jp/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___en-tw",
    path: "/en-tw/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___en-kr",
    path: "/en-kr/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___en-americas",
    path: "/en-americas/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___en-asia-pacific",
    path: "/en-asia-pacific/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___ja-jp",
    path: "/ja-jp/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___zh-cn",
    path: "/zh-cn/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "products-id-slug___zh-tw",
    path: "/zh-tw/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93mAeeHSIUs2C2NbRite6U6kuxN8F9ie51jcKYtjGNzUkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "help-sales-support___en-int",
    path: "/en-int/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___en-emea",
    path: "/en-emea/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___en-jp",
    path: "/en-jp/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___en-tw",
    path: "/en-tw/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___en-kr",
    path: "/en-kr/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___en-americas",
    path: "/en-americas/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___en-asia-pacific",
    path: "/en-asia-pacific/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___ja-jp",
    path: "/ja-jp/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___zh-cn",
    path: "/zh-cn/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "help-sales-support___zh-tw",
    path: "/zh-tw/help/sales-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "partners-Ecosystem___en-int",
    path: "/en-int/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___en-emea",
    path: "/en-emea/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___en-jp",
    path: "/en-jp/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___en-tw",
    path: "/en-tw/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___en-kr",
    path: "/en-kr/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___en-americas",
    path: "/en-americas/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___en-asia-pacific",
    path: "/en-asia-pacific/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___ja-jp",
    path: "/ja-jp/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___zh-cn",
    path: "/zh-cn/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "partners-Ecosystem___zh-tw",
    path: "/zh-tw/partners/Ecosystem",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "support-support-hub___en-int",
    path: "/en-int/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___en-emea",
    path: "/en-emea/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___en-jp",
    path: "/en-jp/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___en-tw",
    path: "/en-tw/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___en-kr",
    path: "/en-kr/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___en-americas",
    path: "/en-americas/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___en-asia-pacific",
    path: "/en-asia-pacific/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___ja-jp",
    path: "/ja-jp/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___zh-cn",
    path: "/zh-cn/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "support-support-hub___zh-tw",
    path: "/zh-tw/support/support-hub",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "solutions-solution___en-int",
    path: "/en-int/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___en-emea",
    path: "/en-emea/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___en-jp",
    path: "/en-jp/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___en-tw",
    path: "/en-tw/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___en-kr",
    path: "/en-kr/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___en-americas",
    path: "/en-americas/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___en-asia-pacific",
    path: "/en-asia-pacific/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___ja-jp",
    path: "/ja-jp/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___zh-cn",
    path: "/zh-cn/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "solutions-solution___zh-tw",
    path: "/zh-tw/solutions/:solution()",
    meta: index_rpSPv3D1f9wwtYHNDqpesm58bpePO77Tg5Zf0Opf90Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "category-subcategory___en-int",
    path: "/en-int/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___en-emea",
    path: "/en-emea/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___en-jp",
    path: "/en-jp/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___en-tw",
    path: "/en-tw/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___en-kr",
    path: "/en-kr/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___en-americas",
    path: "/en-americas/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___en-asia-pacific",
    path: "/en-asia-pacific/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___ja-jp",
    path: "/ja-jp/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___zh-cn",
    path: "/zh-cn/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "category-subcategory___zh-tw",
    path: "/zh-tw/category/:subcategory()",
    meta: { ...(index6NSnheFEy_nZKGoKwZrcUHpy8mMTcfKgxo3Qpvn98HcMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "help-technical-support___en-int",
    path: "/en-int/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___en-emea",
    path: "/en-emea/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___en-jp",
    path: "/en-jp/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___en-tw",
    path: "/en-tw/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___en-kr",
    path: "/en-kr/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___en-americas",
    path: "/en-americas/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___en-asia-pacific",
    path: "/en-asia-pacific/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___ja-jp",
    path: "/ja-jp/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___zh-cn",
    path: "/zh-cn/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "help-technical-support___zh-tw",
    path: "/zh-tw/help/technical-support",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "redirect-report-center___en-int",
    path: "/en-int/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___en-emea",
    path: "/en-emea/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___en-jp",
    path: "/en-jp/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___en-tw",
    path: "/en-tw/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___en-kr",
    path: "/en-kr/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___en-americas",
    path: "/en-americas/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___en-asia-pacific",
    path: "/en-asia-pacific/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___ja-jp",
    path: "/ja-jp/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___zh-cn",
    path: "/zh-cn/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "redirect-report-center___zh-tw",
    path: "/zh-tw/redirect/report-center",
    meta: indexZ_JUh7NgMtXeFMi84DZW8AuRV3s2XY_45SyIHSHf7dw9EMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-int",
    path: "/en-int/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-emea",
    path: "/en-emea/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-jp",
    path: "/en-jp/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-tw",
    path: "/en-tw/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-kr",
    path: "/en-kr/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-americas",
    path: "/en-americas/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___en-asia-pacific",
    path: "/en-asia-pacific/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___ja-jp",
    path: "/ja-jp/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___zh-cn",
    path: "/zh-cn/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "cta-booking-trackingId___zh-tw",
    path: "/zh-tw/cta/booking/:trackingId()",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-int",
    path: "/en-int/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-emea",
    path: "/en-emea/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-jp",
    path: "/en-jp/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-tw",
    path: "/en-tw/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-kr",
    path: "/en-kr/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-americas",
    path: "/en-americas/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___en-asia-pacific",
    path: "/en-asia-pacific/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___ja-jp",
    path: "/ja-jp/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___zh-cn",
    path: "/zh-cn/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "topics-digital-om-energy___zh-tw",
    path: "/zh-tw/topics/digital-om-energy",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "category-subcategory-generic___en-int",
    path: "/en-int/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___en-emea",
    path: "/en-emea/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___en-jp",
    path: "/en-jp/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___en-tw",
    path: "/en-tw/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___en-kr",
    path: "/en-kr/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___en-americas",
    path: "/en-americas/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___en-asia-pacific",
    path: "/en-asia-pacific/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___ja-jp",
    path: "/ja-jp/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___zh-cn",
    path: "/zh-cn/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "category-subcategory-generic___zh-tw",
    path: "/zh-tw/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93eVGkCHkiYFNAD_kCFx099djJQqwdFlFt1gdbsn2NQogMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/vsts/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "pricing-id-contact-sales___en-int",
    path: "/en-int/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___en-emea",
    path: "/en-emea/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___en-jp",
    path: "/en-jp/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___en-tw",
    path: "/en-tw/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___en-kr",
    path: "/en-kr/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___en-americas",
    path: "/en-americas/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___ja-jp",
    path: "/ja-jp/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___zh-cn",
    path: "/zh-cn/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-contact-sales___zh-tw",
    path: "/zh-tw/pricing/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-request-demo___en-int",
    path: "/en-int/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___en-emea",
    path: "/en-emea/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___en-jp",
    path: "/en-jp/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___en-tw",
    path: "/en-tw/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___en-kr",
    path: "/en-kr/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___en-americas",
    path: "/en-americas/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___ja-jp",
    path: "/ja-jp/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___zh-cn",
    path: "/zh-cn/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "products-id-request-demo___zh-tw",
    path: "/zh-tw/products/:id()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "support-certificated-sales___en-int",
    path: "/en-int/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___en-emea",
    path: "/en-emea/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___en-jp",
    path: "/en-jp/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___en-tw",
    path: "/en-tw/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___en-kr",
    path: "/en-kr/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___en-americas",
    path: "/en-americas/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___en-asia-pacific",
    path: "/en-asia-pacific/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___ja-jp",
    path: "/ja-jp/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___zh-cn",
    path: "/zh-cn/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "support-certificated-sales___zh-tw",
    path: "/zh-tw/support/certificated-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-int",
    path: "/en-int/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-emea",
    path: "/en-emea/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-jp",
    path: "/en-jp/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-tw",
    path: "/en-tw/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-kr",
    path: "/en-kr/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-americas",
    path: "/en-americas/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___ja-jp",
    path: "/ja-jp/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___zh-cn",
    path: "/zh-cn/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "products-id-contact-sales___zh-tw",
    path: "/zh-tw/products/:id()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "solutions-solution-generic___en-int",
    path: "/en-int/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___en-emea",
    path: "/en-emea/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___en-jp",
    path: "/en-jp/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___en-tw",
    path: "/en-tw/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___en-kr",
    path: "/en-kr/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___en-americas",
    path: "/en-americas/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___en-asia-pacific",
    path: "/en-asia-pacific/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___ja-jp",
    path: "/ja-jp/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___zh-cn",
    path: "/zh-cn/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-generic___zh-tw",
    path: "/zh-tw/solutions/:solution()/:generic()",
    meta: indexLqjy6P3pc_45HnAy9XS7xP29vfq_45NX4G7_45bA9ttnCYf5IMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-int",
    path: "/en-int/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-emea",
    path: "/en-emea/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-jp",
    path: "/en-jp/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-tw",
    path: "/en-tw/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-kr",
    path: "/en-kr/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-americas",
    path: "/en-americas/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___ja-jp",
    path: "/ja-jp/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___zh-cn",
    path: "/zh-cn/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-request-demo___zh-tw",
    path: "/zh-tw/solutions/:solution()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-int",
    path: "/en-int/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-emea",
    path: "/en-emea/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-jp",
    path: "/en-jp/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-tw",
    path: "/en-tw/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-kr",
    path: "/en-kr/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-americas",
    path: "/en-americas/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___en-asia-pacific",
    path: "/en-asia-pacific/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___ja-jp",
    path: "/ja-jp/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___zh-cn",
    path: "/zh-cn/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-free-trial___zh-tw",
    path: "/zh-tw/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-int",
    path: "/en-int/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-emea",
    path: "/en-emea/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-jp",
    path: "/en-jp/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-tw",
    path: "/en-tw/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-kr",
    path: "/en-kr/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-americas",
    path: "/en-americas/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___ja-jp",
    path: "/ja-jp/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___zh-cn",
    path: "/zh-cn/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "pricing-id-partnumber-contact-sales___zh-tw",
    path: "/zh-tw/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-int",
    path: "/en-int/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-emea",
    path: "/en-emea/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-jp",
    path: "/en-jp/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-tw",
    path: "/en-tw/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-kr",
    path: "/en-kr/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-americas",
    path: "/en-americas/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___en-asia-pacific",
    path: "/en-asia-pacific/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___ja-jp",
    path: "/ja-jp/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___zh-cn",
    path: "/zh-cn/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "topics-wise-edge-developer-architecture___zh-tw",
    path: "/zh-tw/topics/wise-edge-developer-architecture",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-int",
    path: "/en-int/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-emea",
    path: "/en-emea/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-jp",
    path: "/en-jp/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-tw",
    path: "/en-tw/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-kr",
    path: "/en-kr/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-americas",
    path: "/en-americas/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___ja-jp",
    path: "/ja-jp/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___zh-cn",
    path: "/zh-cn/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "solutions-solution-generic-request-demo___zh-tw",
    path: "/zh-tw/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "ecosystem-overview___en-int",
    path: "/en-int/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___en-emea",
    path: "/en-emea/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___en-jp",
    path: "/en-jp/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___en-tw",
    path: "/en-tw/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___en-kr",
    path: "/en-kr/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___en-americas",
    path: "/en-americas/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___en-asia-pacific",
    path: "/en-asia-pacific/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___ja-jp",
    path: "/ja-jp/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___zh-cn",
    path: "/zh-cn/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-overview___zh-tw",
    path: "/zh-tw/ecosystem/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "ecosystem-list___en-int",
    path: "/en-int/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___en-emea",
    path: "/en-emea/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___en-jp",
    path: "/en-jp/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___en-tw",
    path: "/en-tw/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___en-kr",
    path: "/en-kr/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___en-americas",
    path: "/en-americas/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___en-asia-pacific",
    path: "/en-asia-pacific/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___ja-jp",
    path: "/ja-jp/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___zh-cn",
    path: "/zh-cn/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "ecosystem-list___zh-tw",
    path: "/zh-tw/ecosystem/list",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/partners/Ecosystem/index.vue")
  },
  {
    name: "overview___en-int",
    path: "/en-int/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___en-emea",
    path: "/en-emea/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___en-jp",
    path: "/en-jp/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___en-tw",
    path: "/en-tw/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___en-kr",
    path: "/en-kr/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___en-americas",
    path: "/en-americas/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___en-asia-pacific",
    path: "/en-asia-pacific/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___ja-jp",
    path: "/ja-jp/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___zh-cn",
    path: "/zh-cn/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "overview___zh-tw",
    path: "/zh-tw/overview",
    component: () => import("/home/vsts/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-int/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-emea/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-jp/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-tw/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-kr/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-americas/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/en-asia-pacific/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/ja-jp/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/zh-cn/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  },
  {
    name: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDwMeta?.name,
    path: "/zh-tw/sitemap.xml",
    component: component_45stubqkANER2j4KyJGcrk3IoJL2dvW15WXBaOSL1zp8UiKDw
  }
]